<script>
import ModuleTitle from '../common/ModuleTitle.vue'

import { getShadowColor, getPageThemeColor } from '@/utils/modules/getStyles'

export default {
  name: 'Comp22',
  components: { ModuleTitle },
  props: {
    moduleOption: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      path: this.$route.path
    }
  },
  methods: {
    getShadowColor, getPageThemeColor,
    onModuleItem(v) {
      this.$emit('onModuleItem', v)
    }
  }
}
</script>

<template>
  <div class="modules-id-22">
    <module-title :title="moduleOption.title" margin-bottom="24" />
    <div
      class="comp-transverse-2 modules-id-22-content"
      :style="{boxShadow: `0 4px 15px 0 ${getShadowColor(path)}`}"
    >
      <div class="item-list">
        <div
          v-for="v in moduleOption.list.slice(0, 4)"
          :key="`modules-22-${v.id}`"
          class="item"
          @click="onModuleItem(v)"
        >
          <el-image class="images" :src="v.photo | imgPath" alt="images" fit="cover" />
          <p class="title-text">{{ v.headline | textLenHandler(14) }}</p>
        </div>
      </div>
      <div class="check-more" :style="{backgroundColor: getPageThemeColor(path, 0.1)}">
        <p class="check-text" :style="{color: getPageThemeColor(path)}">查看更多<i class="el-icon-arrow-down" /></p>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.modules-id-22-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  padding: 10px;
  background: #fff;
  border-radius: 5px;
  .item-list {
    width: 632px;
    height: 100%;
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }
  .item {
    width: 311px;
    height: 149px;
    border-radius: 5px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
    position: relative;
  }
  .item::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    box-shadow: rgba(0, 0, 0, 0.9) 0px -110px 110px -110px inset;
    z-index: 2;
  }
  .images {
    position: absolute;
    top: 0;
    left: 0;
    width: 311px;
    height: 149px;
    border-radius: 5px;
    z-index: 1;
  }
  .title-text {
    width: 268px;
    font-size: 17px;
    font-weight: 800;
    color: #fff;
    text-align: start;
    z-index: 3;
    margin-bottom: 15px;
  }
}
.check-more {
  width: 41px;
  height: 307px;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  .check-text {
    writing-mode: vertical-lr;
    font-size: 13px;
    font-weight: bold;
    line-height: 15px;
    letter-spacing: 3px;
    i {
      font-weight: bold;
    }
  }
}
</style>
